import { render } from "./04_DashobardSectionInvoice.vue?vue&type=template&id=690b23af"
import script from "./04_DashobardSectionInvoice.vue?vue&type=script&lang=js"
export * from "./04_DashobardSectionInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__